module.exports = __webpack_public_path__ + "static/media/xanil.2a7ea735.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/corynespora/preventiva/xanil.png
// module id = 2107
// module chunks = 3